module.exports = __webpack_public_path__ + "img/ic_time_primary.b9838647.svg";